import React, { forwardRef, HTMLAttributes } from 'react';
import styled, { css } from 'styled-components';
import { colors } from '../../config/styles';
import { theme } from '../../styles/theme';
import { formInputStyles } from '../../styles/shareableStyles';

// FauxInput component will render an input-like field
interface IProps extends HTMLAttributes<HTMLDivElement> {
  hasError?: boolean;
  isDisabled?: boolean;
}

const Container = styled.div<{ $hasError?: boolean; $isDisabled?: boolean }>`
  min-width: 240px;
  max-width: 480px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
  min-height: 28px;
  padding: 2px 3px;
  cursor: pointer;
  ${formInputStyles};
  &:hover {
    border-color: ${theme.colors.mainBlue};
  }
  &:hover > * div {
    color: ${theme.colors.mainBlue};
  }
  ${({ $hasError }) =>
    $hasError &&
    css`
      border-color: ${colors.mainError};
    `}
  ${({ $isDisabled }) =>
    $isDisabled &&
    css`
      color: ${theme.colors.secondary400};
      background-color: ${theme.colors.level1};
      &:hover {
        border-color: ${theme.colors.border};
        color: ${theme.colors.secondary400};
        background-color: ${theme.colors.level1};
        cursor: default;
      }
    `}
`;

const FauxInput = forwardRef<HTMLDivElement, IProps>(
  ({ children, hasError, isDisabled, ...props }, ref) => {
    return (
      <Container
        ref={ref}
        {...props}
        $hasError={hasError}
        $isDisabled={isDisabled}
      >
        {children}
      </Container>
    );
  },
);

export default FauxInput;
